export const basicFormSubTitle = [
    {
      text: "Use the",
      code: `.form-label `,
    },
    {
      text: "and",
      code: `.form-control `,
    },
    {
      text: "through create basic form.",
    },
];

export const floatingFormSubTitle = [
    {
      text: "Use the",
      code: `.form-label `,
    },
    {
      text: "and",
      code: `.form-control `,
    },
    {
      text: "through create basic form.",
    },
  ];

export const selectSizingSubTitle = [
    {
      code: ".form-select",
    },
    {
      code: `[form-select-lg/form-select-sm].`,
      text: `to trigger the custom styles. You may also choose from small and large custom selects to match our similarly sized text inputs. class:-`,
    },
  ];

export const formControlSizingSubTitle = [
    {
      text: `Set heights using classes like`,
      code: ".form-control-lg",
    },
    {
      code: `.form-control-sm`,
      text: `and`,
    },
  ];

export const fileInputSubTitle = [
    {
      code: `<input>`,
      text: `For default file/multiple file/disabled file/small file/large file input for use`,
    },
    {
      code: `(type='file').`,
      text: `with`,
    },
  ];

export const flatInputStyleSubTitle = [
    {
      code: `.btn-square `,
      text: `Use the`,
    },
    {
      text: `through defined 0px border-radius.`,
    },
  ];

export const multiplePaintingsItems = ["Landscape", "Portrait ", "Oil Painting", "Abstract art", "Acrylic"]

export const basicHTMLSubTitle = [
    {
      text: `Give textual form controls like`,
      code: `<input>`,
    },
    {
      code: `<textarea>`,
      text: `s and`,
    },
    {
      text: "s an upgrade with custom styles, sizing, focus states, and more.",
    }
  ];

  export const countryList = ["San Francisco", "New York", "Seattle", "Los Angeles", "Chicago", "India"]

  export const basicFloatSubTitle = [
    {
      text: `Give textual form controls like`,
      code: `<input>`,
    },
    {
      code: `<textarea>`,
      text: `s and`,
    },
    {
      text: "s an upgrade with custom styles, sizing, focus states, and more.",
    }
  ];

  export const edgesInputStyleSubTitle = [
    {
      text: `Use the`,
      code: `.btn-pill`,
    },
    {
      text: `through defined border-radius.`,
    },
  ];

export const themeList = ["Tivo","Cuba","Roxo","Oslo","Voxo","Sheltos ","Petkart","Zeta",];

export const raiseInputStyleSubTitle = [
    {
      text: `Use the`,
      code: `input-air-*`,
    },
    {
      text: `through defined bottom box-shadow.`,
    },
  ];

 export const colorList = ["Red", "Yellow", "Orange", "White", "Black", "Gray ", "Brown", "Purple ", "White"]